import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { isIos } from "../capacitor/appsHelpers";

export default function useBottomNavigationParams() {
	const [historyList, setHistoryList] = useState({});
	const history = useHistory();

	const getHistoryPath = (value) => {
		const [, key] = value.split("/");
		const [, currentKey] = location.pathname.split("/");

		if (isIos() && historyList[key] && key !== currentKey) {
			return historyList[key];
		}

		return value;
	};

	useEffect(() => {
		const addToHistoryList = (pathname) => {
			const [, key] = pathname.split("/");

			setHistoryList({
				...historyList,
				[key]: pathname,
			});
		};

		history.listen((location) => {
			addToHistoryList(location.pathname);
		});
	}, [history.listen, historyList]);

	return { historyList, getHistoryPath };
}
